import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  containerLogo: {
    justifyContent: "flex-start",
    overflow: "hidden",
    display: "flex",
    borderRadius: "100%",
  },
  imageLogo: { objectFit: "contain", width: "12ch" },
}));
